const STATUS = {
  "1": "待付款",
  "2": "待开始",
  "3": "进行中",
  "4": "已完成",
  "5": "已退款" // Based on previous sample data status: 5
};

export default (Vue) => {
  return [
    {
      title: "订单ID",
      key: "id",
      minWidth: 100,
      align: 'center'
    },
    {
      title: "服务内容",
      key: "description",
      minWidth: 150,
      align: 'center'
    },
    {
      title: "图片",
      key: "pictures",
      align: 'center',
      minWidth: 120,
      render: (h, { row }) => {
        if (!row.pictures) return h('span', '-');
        const imgList = row.pictures.split(',');
        return h('div', {
          style: {
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }
        }, imgList.map(url => {
          return h('el-popover', {
            props: {
              placement: 'right',
              trigger: 'hover',
              width: 220
            }
          }, [
            h('img', {
              attrs: { src: url },
              style: { width: '200px' }
            }),
            h('img', {
              slot: 'reference',
              attrs: { src: url },
              style: {
                width: '40px',
                height: '40px',
                margin: '2px',
                cursor: 'pointer',
                objectFit: 'cover'
              }
            })
          ]);
        }));
      }
    },
    {
      title: "订单状态",
      key: "status",
      minWidth: 120,
      align: 'center',
      render: (h, { row }) => {
        const text = STATUS[String(row.status)] || row.status;
        return h('span', {}, text);
      }
    },
    {
      title: "价格(元)",
      key: "price",
      align: 'center',
      minWidth: 100
    },
    {
      title: "联系电话",
      key: "phone",
      align: 'center',
      minWidth: 130
    },
    {
      title: "服务地址",
      key: "region",
      align: 'center',
      minWidth: 200
    },
    {
      title: "预约时间",
      key: "appointmentTime",
      align: 'center',
      minWidth: 160
    },
    {
      title: "下单时间",
      key: "createDt",
      align: 'center',
      minWidth: 160
    },
    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      align: 'center',
      width: 150,
      render: (h, { row }) => {
        const buttons = [];
        
        // 取消订单按钮 (针对待支付、待接单等状态)
        if ([-1, 0, 1, 2].includes(row.status)) {
          buttons.push(
            h('Button', {
              props: {
                type: 'text',
                size: 'small',
              },
              style: {
                color: "#FF4D4F"
              },
              on: {
                click: () => {
                  Vue.handleCancelOrder(row.id, row.id);
                }
              }
            }, '取消')
          );
        }
        
        // 转单/派单按钮 (针对待接单等状态)
        if ([0, 1].includes(row.status)) {
            buttons.push(
              h('Button', {
                props: {
                  type: 'text',
                  size: 'small',
                },
                style: {
                  color: "#3091FF",
                  marginLeft: "8px"
                },
                on: {
                  click: () => {
                    Vue.handleTransferOrder(row.id);
                  }
                }
              }, '转单')
            );
          }

        return h('div', buttons);
      }
    }
  ]
}
